/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { ReactNode } from 'react';
import TableCell from '@mui/material/TableCell';

interface HeaderTemplateProps {
  title: ReactNode;
  unit: ReactNode;
}

export default function HeaderCellTemplate({ title, unit }: HeaderTemplateProps) {
  return (
    <TableCell>
      {title}
      <span>{unit}</span>
    </TableCell>
  );
}
